import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import get from "lodash/get";
import AsyncSelect from 'react-select/async';
import { customStyles } from '../custom-select/custom-styles';
import { CustomInput } from '../custom-select/CustomInput';
import { CustomMenuList } from '../custom-select/CustomMenuList';
import { CustomOption } from '../custom-select/CustomOption';
import { locationInputPropTypes } from '../location-input-prop-types';
import { useLocationInput } from '../use-location-input';
import { useSearch } from '../../SearchForm/use-search';

export const MobileLocationInput = (props) => {
  const { intl, setMobileTrayView, mobileTrayViewValue } = useSearch();
  const placeholder = intl.formatMessage({
    id: 'shared_components.location-input.async-select-placeholder',
    defaultMessage: 'Enter a city or address'
  });

  const {
    fetchSuggestions,
    isFocused,
    defaultOptions,
    inputDisplay,
    value,
    formActive,
    isOptionError,
    onChange,
    inputChange,
    handleInputFocus,
    handleInputBlur,
    handleContainerFocus
  } = useLocationInput(props);

  const [mobileInputFocused, setMobileInputFocused] = useState(false);

  const getInputColorClass = () => {
    let colorClass = '';
    if (formActive && !isFocused) {
      colorClass += 'text-gray-500';
    } else {
      colorClass += value ? 'text-gray-900' : 'text-gray-600';
    }
    return colorClass;
  };

  const label = intl.formatMessage({
    id: 'shared_components.activity-input.location-input-label',
    defaultMessage: 'Where?'
  });

  const readonlyInput = (
    <button
      className={classNames(
        'readonly_location_input',
        'btn-clear text-large',
        getInputColorClass()
      )}
      onClick={(e) => {
        e.preventDefault();
        setMobileTrayView('location');
      }}
    >
      {inputDisplay || placeholder}
    </button>
  );

  const handleOnChangeMobile = (...args) => {
    onChange(...args, undefined, (action) => {
      if ('clear' !== action) {
        setMobileTrayView('main');
      }
    });
  };

  return (
    <>
      {
        'main' === mobileTrayViewValue &&
          <div className="flex search_form_input_wrap_mobile responsive-padding">
            <div
              className={classNames('location_input_wrap', 'flex column')}
              role="button"
              tabIndex="0"
              onFocus={(e) => {
                handleContainerFocus(e);
              }}
            >
              <>
                <label
                  className="location_input_label text-gray-900 text-small"
                >
                  {label}
                </label>
                {readonlyInput}
              </>
            </div>
          </div>
      }
      {
        'location' === mobileTrayViewValue &&
          <div className="flex search_form_input_wrap_mobile responsive-padding">
            <div
              className="location_input_wrap mt-md pb-sm flex column center"
              onFocus={() => setMobileInputFocused(true)}
              onBlur={() => setMobileInputFocused(false)}
              role="button"
              tabIndex="0"
            >
              <AsyncSelect
                id="location-input"
                inputValue={inputDisplay}
                controlShouldRenderValue={false}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                placeholder={placeholder}
                isClearable
                openMenuOnFocus
                instanceId="location-input"
                onChange={handleOnChangeMobile}
                onInputChange={inputChange}
                defaultOptions={defaultOptions}
                loadOptions={fetchSuggestions}
                noOptionsMessage={() => null}
                getOptionValue={(suggestion) => suggestion.value}
                styles={customStyles(isFocused, formActive, true)}
                components={{
                  MenuList: (props) => CustomMenuList(props, isOptionError),
                  Option: CustomOption,
                  LoadingIndicator: () => null,
                  IndicatorsContainer: () => null,
                  Input: CustomInput
                }}
              />
            </div>
          </div>
      }
    </>
  );
};

MobileLocationInput.propTypes = locationInputPropTypes;
